import { SuperAdminFeatureFlagsManager } from './SuperAdminFeatureFlagsManager';
import { SuperAdminModal, SuperAdminModalStyles } from './SuperAdminModal';

interface FeatureFlagsModalProps {
  visible: boolean;
  onClose: () => void;
  styles?: SuperAdminModalStyles;
}

export const FeatureFlagsModal = ({ visible, onClose, styles }: FeatureFlagsModalProps) => (
  <SuperAdminModal visible={visible} title={'Feature Flags'} onClose={onClose} styles={styles}>
    <SuperAdminFeatureFlagsManager />
  </SuperAdminModal>
);
